<template>
  <div>
    <table class="table table-fixed table-bordered" v-if="uploadStatus !== 'success'">
      <tbody>
      <tr>
        <th>
          Berichtdatum
        </th>
        <td>
          {{ messageDate }}
        </td>
      </tr>
      <tr>
        <th>
          {{ attachmentAttributeDescriptionByLabel(attachment, 'BYLSRT') }}
        </th>
        <td>
          {{ attachmentAttributeCodeListDescriptionByLabel(attachment, 'BYLSRT') }}
        </td>
      </tr>
      <tr>
        <th v-if="attachmentAttributeDescriptionByLabel(attachment, 'FILNM') !== ''">
          {{ attachmentAttributeDescriptionByLabel(attachment, 'FILNM') }}
        </th>
        <th v-else>Bestandsnaam</th>
        <td>
          <a-input v-model="attachmentName"></a-input>
        </td>
      </tr>
      <tr>
        <th>
          Kies een maatschappij
        </th>
        <td>
          <select-agency-component
              fieldName="agency-select"
              :allow-clear="true"
              @agency-selected="selectAgency"
          />
        </td>
      </tr>
      <tr v-if="hasAgency">
        <th>
          Bijlage wordt opgeslagen in de folder
        </th>
        <a-select class="attachment-category-select"
                  style="width:100%; padding: 1rem;" v-model="chosenCategoryId">
          <a-select-option v-for="(category, key) in agency.attachable_categories.data"
                           :key="key" :value="category.id"
          >
            {{ category.name }}
          </a-select-option>
        </a-select>
      </tr>
      <tr v-if="hasAgency && chosenCategoryId !== null">
        <th>
          <progress style="width: 100%; height: 3rem" max="100" :value.prop="uploadPercentage"
                    v-if="uploadStarted"></progress>
        </th>
        <td>
          <a-button @click="uploadAttachment" type="primary" :loading="uploading">Bijlage opslaan</a-button>
          <span v-if="uploadStatus === 'error'" class="label-warning">{{ errorMessage }}</span>
        </td>
      </tr>
      </tbody>
    </table>
    <span v-else><i class="mdi mdi-check-bold"/>Bijlage opgeslagen</span>
  </div>
</template>

<script>
import {SIVIEntityLabelEnum} from '~/enums'
import agencyApi from '~/api/agency';
import documentApi from '~/api/document';
import store from '../../../store';
import siviModule from '../store'
import siviAttributeComponent from "~/modules/sivi/components/SiviAttributeComponent";
import selectAgencyComponent from '~/modules/agency/components/SelectAgencyComponent'

export default {
  name: "UploadSiviMessageAttachmentComponent",
  props: {
    attachment: {
      type: Object,
      required: true
    },
    porCode: {
      type: String,
      default: null,
      required: false
    },
    messageDate: {
      type: String,
      default: null,
      required: false
    }
  },
  data() {
    return {
      siviMessage: null,
      agency: null,
      linkAttachmentToCategory: null,
      chosenCategoryId: null,
      attachmentName: '',
      attachmentMimeType: '',
      uploadPercentage: 0,
      uploadResponse: null,
      errorMessage: '',
      uploading: false,
      uploadStarted: false
    }
  },
  computed: {
    hasAgency() {
      return this.agency !== null;
    },
    uploadStatus() {
      if (this.uploadResponse !== null) {
        return this.uploadResponse
      }
      return false
    },
    chosenCategoryIsTemplate() {
      if (typeof this.chosenCategoryId !== 'undefined' && this.chosenCategoryId !== null) {
        const chosenCategory = this.agency.attachable_categories.data.filter(category => category.id === this.chosenCategoryId)[0];

        if (typeof chosenCategory !== 'undefined' && chosenCategory !== null) {
          return chosenCategory.template;
        }
      }
      return false
    },
  },
  created() {
    if (!store.hasModule('sivi')) {
      store.registerModule('sivi', siviModule)
    }
  },
  mounted() {
    if (this.porCode !== null) {
      agencyApi.findByPorCode(this.porCode).then(response => {
        this.agency = response.data;
      })
    }
    this.attachmentName = this.attachmentAttributeValueByLabel(this.attachment, 'FILNM')
    documentApi.getMimeTypeByExtention(
        this.attachmentAttributeValueByLabel(
            this.attachment,
            SIVIEntityLabelEnum.FILE_EXTENSION
        )).then(response => {
      this.attachmentMimeType = response;
    });
  },
  components: {
    siviAttributeComponent,
    selectAgencyComponent
  },
  methods: {
    attachmentAttributeValueByLabel(attachment, attributeLabel) {
      let value = '';

      attachment.attributes.forEach(attribute => {
        if (attribute.label === attributeLabel) {
          value = attribute.value;
        }
      })
      return value;
    },
    attachmentAttributeDescriptionByLabel(attachment, attributeLabel) {
      let description = '';

      attachment.attributes.forEach(attribute => {
        if (attribute.label === attributeLabel) {
          description = attribute.description;
        }
      })
      return description;
    },
    attachmentAttributeCodeListDescriptionByLabel(attachment, attributeLabel) {
      let codeListDescription = '';

      attachment.attributes.forEach(attribute => {
        if (attribute.label === attributeLabel) {
          codeListDescription = attribute.codeListDescription;
        }
      })
      return codeListDescription;
    },
    uploadAttachment() {
      this.uploading = true
      this.uploadStarted = true
      let file = this.attachmentAttributeValueByLabel(this.attachment, SIVIEntityLabelEnum.FILE_DATA),
          buffer = Buffer.from(file, 'base64'),
          content = buffer.toString(),
          blob = this.converBase64toBlob(file, this.attachmentMimeType),
          mediaItem = this.$refs.progressbar,
          name = this.attachmentName,
          fd = new FormData()

      // append form data
      fd.append("name", name);
      fd.append("content", blob, name);
      fd.append("category_id", this.chosenCategoryId);
      fd.append("without_customer", true);
      // fd.append("_token", document.querySelector('meta[name="csrf-token"]').getAttribute('content'));
      fd.append("_token", window.state.csrf_token);
      fd.append("has_attachable_id", this.agency.id);
      fd.append("has_attachable_type", 'agency');
      fd.append("attachable_category_id", this.chosenCategoryId);
      fd.append("template", this.chosenCategoryIsTemplate);
      fd.append("extension", this.attachmentAttributeValueByLabel(this.attachment, SIVIEntityLabelEnum.FILE_EXTENSION));
      fd.append("mime_type", this.attachmentMimeType);

      // start uploading progress
      let xhr = new XMLHttpRequest();

      xhr.upload.addEventListener("progress", function (evt) {
        this.uploadPercentage = parseInt(Math.round((evt.loaded / evt.total) * 100));
      }.bind(this))

      xhr.addEventListener("load", function (evt) {
        let json = JSON.parse(evt.target.response);
        if (json.data.success === true) {
          this.uploadResponse = 'success'
        } else if (evt.target.status === 413) {
          this.uploadResponse = 'error'
          this.errorMessage = 'Het bestand "' + $(mediaItem).data('name') + '" is te groot';
        } else {
          this.uploadResponse = 'error'
          this.errorMessage = 'Er is iets mis gegaan tijdens het verwerken van de bijlage';
        }
      }.bind(this), false);
      xhr.open("POST", "/web_api/v1/document/store");
      xhr.setRequestHeader('Accept', 'application/json');
      xhr.send(fd);
      this.uploading = false
    },

    uploadFailed(evt) {
      this.uploadResponse = 'error'
      this.errorMessage = 'Er is iets mis gegaan tijdens het verwerken van de bijlage';
    },

    uploadCanceled(evt) {
      this.uploadResponse = 'error'
      this.errorMessage = 'Het opslaan is geannuleerd';
    },

    readableFileSize(size) {
      size = Number(size);
      let units = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
      let i = 0;
      while (size >= 1024) {
        size /= 1024;
        ++i;
      }
      return size.toFixed(1) + ' ' + units[i];
    },

    converBase64toBlob(content, contentType) {
      contentType = contentType || '';
      let sliceSize = 512;
      let byteCharacters = window.atob(content); //method which converts base64 to binary
      let byteArrays = [];
      for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
        let slice = byteCharacters.slice(offset, offset + sliceSize);
        let byteNumbers = new Array(slice.length);
        for (let i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i);
        }
        let byteArray = new Uint8Array(byteNumbers);
        byteArrays.push(byteArray);
      }
      //statement which creates the blob
      return new Blob(byteArrays, {
        type: contentType
      });
    },
    selectAgency(value) {
      this.chosenCategoryId = null;
      this.agency = value.agency;
    },
  },
}
</script>

<style scoped>
.csv-export-component {
}

table.table th, table.table td {
  padding: 1.5rem 1rem;
}
</style>